export default [
  {
    key: '2', 
    name: '库管报表', 
    icon: 'line-chart', 
    submenus: [
      { key: '/report/sale_report', code: 'sales_report',name: '出库报表' },
      { key: '/report/purchase_report', code: 'purchase_report',name: '入库报表' },
      { key: '/report/stock_report', code: 'inventory',name: '库存报表' },
      // { key: '/report/income_expense_statistics', code: 'finance_statistic',name: '收支统计' },
      // { key: '/report/batch_report', code: 'batch',name: '批次报表' },
    ]
  },
  {
    key: '3', 
    name: '库管基础数据', 
    icon: 'table', 
    submenus: [
      { key: '/basicData/client', code: 'client',name: '领用人管理'},
      { key: '/basicData/supplier', code: 'supplier',name: '产品来源管理'},
      { key: '/basicData/warehouse', code: 'warehouse',name: '仓库管理'},
      { key: '/basicData/settlement_account', code: 'settlement_account',name: '结算账户'},
      // { key: '/basicData/revenue_expenditure_items', code: 'charge_item',name: '收支项目'},
      { key: '/goods/classification', code: 'goods_category',name: '产品分类' },
      { key: '/goods/unit', code: 'goods_unit',name: '产品单位' },
      { key: '/goods/information', code: 'goods',name: '产品信息' },
      { key: '/goods/temporary_warning', code: 'goods',name: '临期预警' },
    ]
  },
  // {
  //   key: '4', 
  //   name: '库管产品', 
  //   icon: 'appstore', 
  //   submenus: [
  //     { key: '/goods/classification', code: 'goods_category',name: '产品分类' },
  //     { key: '/goods/unit', code: 'goods_unit',name: '产品单位' },
  //     { key: '/goods/information', code: 'goods',name: '产品信息' },
  //     { key: '/goods/temporary_warning', code: 'goods',name: '临期预警' },
  //   ]
  // },
  {
    key: '5', 
    name: '出入库管理', 
    icon: 'shopping-cart', 
    submenus: [
      { key: '/purchasing/purchase_create', code: 'purchase_order',name: '入库开单' },
      { key: '/purchasing/purchase_record', code: 'purchase_order',name: '入库记录' },
      // { key: '/purchasing/purchase_return_create', code: 'purchase_return_order',name: '入库退货' },
      // { key: '/purchasing/return_record', code: 'purchase_return_order',name: '退货记录' },
      { key: '/sale/sale_create', code: 'sales_order',name: '出库开单' },
      { key: '/sale/sale_record', code: 'sales_order',name: '出库记录' },
    ]
  },
  // {
  //   key: '6', 
  //   name: '出库管理', 
  //   icon: 'shopping', 
  //   submenus: [
  //     { key: '/sale/sale_create', code: 'sales_order',name: '出库开单' },
  //     { key: '/sale/sale_record', code: 'sales_order',name: '出库记录' },
  //     { key: '/sale/sale_return_create', code: 'sales_return_order',name: '出库退货' },
  //     { key: '/sale/sale_return_record', code: 'sales_return_order',name: '退货记录' },
  //   ]
  // },
  {
    key: '8', 
    name: '库存管理', 
    icon: 'database', 
    submenus: [
      { key: '/warehouse/inStock',  code: 'stock_in', name: '入库任务' },
      { key: '/warehouse/outStock',  code: 'stock_out', name: '出库任务' },
      { key: '/warehouse/inventory',  code: 'stock_check', name: '盘点' },
      { key: '/warehouse/allocation',  code: 'stock_transfer', name: '调拨' },
      { key: '/warehouse/flow',  code: 'inventory_flow',  name: '库存流水' },
    ]
  },
  {
    key: '13',
    name: '物业管理',
    icon: 'exclamation-circle',
    submenus: [
      { key: '/inspection/list', code: 'inspection_manage', name: '巡视管理' },
      { key: '/complaint/complaintorders', code: 'complaint_order_list', name: '工单列表' },
      { key: '/complaint/complaintorders/stats', code: 'complaint_order_stats', name: '统计分析' },
      { key: '/complaint/workplan/list', code: 'complaint_workplan_list', name: '物业管理工作计划' },
    ]
  },
  {
    key: '10',
    name: '工程维修',
    icon: 'tool',
    submenus: [
      { key: '/check_patrol/list', code: 'check_patrol_manage', name: '巡查管理' },
      { key: '/repair/workorders', code: 'repair_order_list', name: '工单列表' },
      { key: '/repair/workorders/stats', code: 'repair_order_stats', name: '统计分析' },
      { key: '/repair/workplan/list', code: 'repair_workplan_list', name: '工程维修工作计划' },
    ]
  },
  {
    key: '12',
    name: '安保应急',
    icon: 'security-scan',
    submenus: [
      { key: '/security/securityorders', code: 'security_order_list', name: '工单列表' },
      { key: '/security/securityorders/stats', code: 'security_order_list', name: '统计分析' },
      { key: '/security/workplan/list', code: 'security_workplan_list', name: '安保应急工作计划' },
    ]
  },
  {
    key: '14',
    name: '物业通知',
    icon: 'notification',
    submenus: [
      { key: '/notice/send', code: 'send_notice', name: '群发通知' },
      { key: '/notice/send_history', code: 'notice_order_stats', name: '通知查询统计' },
    ]
  },
  {
    key: '19',
    name: '巡逻管理',
    icon: 'security-scan',
    submenus: [
      // { key: '/patrol/batch_create', code: 'patrol_plan_batch_create', name: '批量创建巡逻计划' },
      { key: '/patrol/patrol_daily_overview', code: 'patrol_daily_overview', name: '今日巡逻计划' },
      { key: '/patrol', code: 'patrol_plan_list', name: '巡逻计划列表' },
      { key: '/patrol/patrolman_bind', code: 'patrol_man_bind', name: '巡逻人员绑定' },
      { key: '/patrol/checkpoint_manage', code: 'checkpoint_manage', name: '巡检点管理' },
      { key: '/patrol/checkpoint_logs', code: 'checkpoint_logs', name: '巡检记录查询' },
      { key: '/patrol/patrol_group_list', code: 'patrol_group_list', name: '巡逻区域列表' },
    //   { key: '/patrol/patrol_workplan_create', code: 'patrol_workplan_create', name: '巡检计划创建' },
    ]
  },
  
  {
    key: '9', name: '财务管理', icon: 'dollar', submenus: [
      { key: '/finance/arrears_payable', name: '应付欠款' },
      { key: '/finance/payment', name: '付款' },
      { key: '/finance/arrears_receivable', name: '应收欠款' },
      { key: '/finance/collection', name: '收款' },
      { key: '/finance/account_transfer', name: '账户转账' },
      { key: '/finance/income_and_pay', name: '日常收支' },
      { key: '/finance/flow', name: '资金流水' },
      { key: '/finance/owner_payment_query', code: 'owner_payment_entry_query', name: '业主缴费查询' },
      { key: '/finance/reconciliation_export', code: 'finance_reconciliation_export', name: '对账报表导出' },
    ]
  },
  
  {
    key: '16', name: '态势感知-总部', icon: 'dashboard', submenus: [
      { key: '/boss-dashboard', code: 'situational_awareness', name: '总部展示' },
    ]
  },
  {
    key: '17', name: '业主管理', icon: 'team', submenus: [
      { key: '/owner_mg/fee_query', code: 'fee_query', name: '缴费查询' },
      { key: '/owner_mg/fee_query_for_finance', code: 'fee_query_for_finance', name: '财务专用缴费查询' },
      { key: '/owner_mg/owner_query', code: 'owner_query', name: '业主信息管理' },
      // { key: '/owner_mg/owner_entry', code: 'owner_entry', name: '业主录入' },
      { key: '/owner_mg/owner_fee_bill_generate', code: 'owner_fee_bill_generate', name: '业主缴费账单生成' },
      // { key: '/owner_mg/community_fee_bill_generate', code: 'community_fee_bill_generate', name: '项目缴费账单生成' },
    ]
  },
  {
    key: '18', name: '配送管理', icon: 'inbox', submenus: [
      { key: '/delivery_orders/deliveryorders', code: 'delivery_order_list', name: '配送订单列表' },
    ]
  },
  {
    key: '11',
    name: '雇员管理',
    icon: 'user',
    submenus: [
      { key: '/employees', code: 'employee_list', name: '雇员列表' },
      // { key: '/employees/create', code: 'employee_create', name: '雇员录入' },
    ]
  },
  {
    key: '20',
    name: '水电管理',
    icon: 'bulb',
    submenus: [
      { key: '/electricity/topology', code: 'electricity_meter_topology', name: '水电表网络图' },
      { key: '/electricity/meter-hierarchy-loss', code: 'electricity_meter_topology', name: '水电表层级损耗计算' },
      { key: '/electricity/accounts/business', code: 'electricity_account_business_list', name: '水电账单中心' },
      { key: '/electricity/accounts/business_for_finance', code: 'electricity_account_business_list_for_finance', name: '财务专用账单中心' },
      { key: '/electricity/manual_entry', code: 'electricity_manual_reading', name: '手工录入抄表' },
      // { key: '/electricity/accounts', code: 'electricity_account_manage', name: '业主信息管理' },
      // { key: '/electricity/meters', code: 'electricity_meter_manage', name: '电表管理' },
      { key: '/electricity/binding', code: 'electricity_account_meter_binding', name: '水电表管理' },
      { key: '/electricity/readings/query', code: 'electricity_meter_topology', name: '抄表记录查询' },
    ]
  },
  {
    key: '22',
    name: 'AI实用工具',
    icon: 'robot',
    submenus: [
      { key: '/ai_tools/promo_copy_from_image', code: 'ai_tools_promo_copy_generate', name: '图生文推广文案' },
      { key: '/ai_tools/tong_cheng58_parser', code: 'ai_tools_promo_copy_generate', name: '58同城招租整理' },
      { key: '/ai_tools/ai_notice_writer', code: 'ai_tools_promo_copy_generate', name: 'AI通知写作助手' },
      { key: '/ai_tools/ragflow_qa_manage', code: 'can_manage_ragflow_qa', name: '问答数据库配置' },
    ]
  },
  // {
  //   key: '21',
  //   name: '小红书发布',
  //   icon: 'share-alt',
  //   submenus: [
  //     { key: '/xiaohongshu/automedia', code: 'xiaohongshu_posting', name: '小红书自动发布' },
  //   ]
  // },
  {
    key: '15', 
    name: '系统管理', 
    icon: 'team', 
    submenus: [
      { key: '/role', code: 'role_manage', name: '角色管理' },
      { key: '/account', code: 'staff_account', name: '员工账号' },
      //{ key: '/config', code: 'system_config', name: '系统配置' },
    ]
  },

]